{
  "fleetSizeQuestion": "Quantos motoristas tem hoje na sua frota?",
  "fleetSizeHint": "Só para conhecermos a sua operação — vai escolher as licenças a ativar no passo seguinte.",
  "fleetSizeOptionDrivers": "{{range}} motoristas",
  "fleetSizeSaveError": "Não foi possível guardar. Tente novamente.",
  "productQuestion": "Que produto quer ativar?",
  "productHint": "Escolha um produto agora — pode combinar diferente mais tarde no painel.",
  "productOption_hours": "Horas",
  "productOption_hoursDescription": "Regista horários, pausas e descansos, facilita a conformidade legal e substitui o registo manual do LIC.",
  "productOption_gps": "GPS",
  "productOption_gpsDescription": "Localiza veículos em tempo real e ajuda a acompanhar a operação e a responder a imprevistos.",
  "productOption_combo": "Controlo de Horas + GPS (Combo)",
  "productOption_comboDescription": "Reúne o controlo de horas e a localização em tempo real para gerir conformidade e operação no mesmo serviço.",
  "licensesQuestion": "Quantas licenças quer ativar agora?",
  "licensesHint": "Pode ativar menos licenças do que motoristas — e adicionar mais em qualquer altura.",
  "licensesSuggested": "Sugestão para {{range}} motoristas: {{count}}",
  "licensesInvalid": "Indique um número entre 1 e {{max}}.",
  "licensesInputLabel": "Número de licenças",
  "licensesIncrease": "Aumentar licenças",
  "licensesDecrease": "Diminuir licenças",
  "licensesTrialNoCard": "Teste gratuito de {{days}} dias — sem cartão para começar.",
  "trialCardUpfront": "Teste gratuito de {{days}} dias — o cartão é pedido já, mas só é cobrado no fim do teste.",
  "licensesAnswer": "{{count}} licenças",
  "startFreeTrial": "Começar teste gratuito",
  "loading": "A carregar…",
  "stripeLoadErrorTitle": "Não foi possível carregar o pagamento seguro",
  "stripeLoadErrorMessage": "O bloqueador de anúncios, a rede ou o CDN do Stripe pode ter impedido o carregamento. Tenta novamente ou contacta o suporte para concluir a compra.",
  "tryAgain": "Tentar novamente",
  "contactSupport": "Contactar suporte",
  "gpsContractAcceptErrorTitle": "Não foi possível aceitar o contrato",
  "gpsContractAcceptErrorMessage": "Ocorreu um erro ao registar a aceitação do contrato GPS. Tenta novamente; se persistir, contacta o suporte.",
  "gpsContractLoadError": "Não foi possível carregar o contrato GPS. Tente novamente.",
  "gpsContractVersionChangedTitle": "O contrato foi atualizado",
  "gpsContractVersionChangedMessage": "Foi publicada uma nova versão do contrato GPS. Leia a versão apresentada antes de aceitar.",
  "onboardingWelcomeTitle": "Bem-vindo à aplicação!",
  "onboardingWelcomeDescription": "Vamos configurar algumas informações importantes antes de começar. Isto vai ajudar-nos a personalizar a sua experiência.",
  "onboardingTitle": "Configuração Inicial",
  "continue": "Continuar",
  "employmentTitle": "Informação de Emprego",
  "loadingEmploymentInfo": "A carregar informações...",
  "employmentDataFound": "Encontrámos as suas informações de emprego:",
  "edit": "Editar",
  "retry": "Tentar Novamente",
  "networkError": "Não foi possível carregar os dados de emprego. Verifique a sua ligação à internet e tente novamente.",
  "employmentFormIntro": "Indique as informações sobre o seu emprego:",
  "companyName": "Nome da Empresa",
  "companyNipc": "NIF/NIPC da Empresa",
  "nipcError": "O NIF/NIPC deve conter 9 dígitos",
  "companyEmail": "E-mail da Empresa",
  "companyPhone": "Telefone da Empresa",
  "payerQuestion": "Quem paga a licença de trabalho?",
  "payerCompany": "A minha empresa paga",
  "payerSelf": "Eu pago a minha licença",
  "payerRequired": "Escolha quem paga.",
  "permissionsTitle": "Permissões da Aplicação",
  "permissionsDescription": "Para oferecer a melhor experiência, precisamos das seguintes permissões:",
  "notificationsPermission": "Notificações",
  "notificationsPermissionMessage": "Para receber notificações, tem de ativar esta permissão nas definições do dispositivo.",
  "notificationsPermissionTitle": "Notificações",
  "notificationsPermissionDescription": "Para receber alertas e informações importantes",
  "locationPermission": "Localização",
  "locationPermissionMessage": "Para usar a sua localização atual, tem de ativar esta permissão nas definições do dispositivo.",
  "locationForegroundPermissionTitle": "Localização (Em uso)",
  "locationForegroundPermissionDescription": "Para mostrar a sua localização atual no mapa",
  "backgroundLocationPermission": "Localização (Segundo plano)",
  "backgroundLocationPermissionMessage": "Para usar a sua localização em segundo plano, tem de ativar esta permissão nas definições do dispositivo. Selecione 'Permitir sempre' para a aplicação funcionar corretamente.",
  "locationBackgroundError": "Permissão necessária",
  "locationBackgroundErrorMessage": "Tem de ativar a localização em primeiro plano antes de a ativar em segundo plano.",
  "locationBackgroundPermissionImportant": "Importante: para receber notificações quando estiver parado no mesmo local durante algum tempo, selecione 'Permitir sempre' nas definições de localização do dispositivo.",
  "finish": "Concluir",
  "ownerWelcomeTitle": "Experimente a solução definitiva de gestão de frotas!",
  "ownerWelcomeDescription": "Controle as horas de trabalho e acompanhe os veículos em tempo real com GPS. Otimize as operações e assegure a conformidade.",
  "ownerFeaturesTitle": "Principais Funcionalidades",
  "ownerFeatureLiveTracking": "Localização de dispositivos GPS com mapa em tempo real",
  "ownerFeatureReports": "Registo automático de horas e relatórios de conformidade",
  "ownerFeatureLicense": "Licenças separadas para Horas e GPS",
  "reviewSetupTotal": "Instalação cobrada uma vez: {{total}}.",
  "licensesShort": "licenças",
  "eligibilityUnavailable": "Não foi possível validar a elegibilidade deste plano. Nenhuma cobrança foi iniciada.",
  "processing": "A processar…",
  "trialDescription": "Será encaminhado para o pagamento seguro para concluir a subscrição.",
  "paymentDescription": "Será encaminhado para o pagamento seguro para concluir a compra.",
  "cancel": "Cancelar",
  "continueToTrial": "Continuar para o teste",
  "planType": {
    "hours": "Horas",
    "gps": "GPS",
    "combo": "Combo (Horas + GPS)"
  },
  "ownerTrialButton": "Inicie Seu Teste Gratuito",
  "trialModalTitle": "Inicie o seu teste gratuito de 7 dias",
  "trialModalDescription": "Introduza os seus dados de pagamento para iniciar um período experimental de 7 dias. Só será cobrado quando este terminar.",
  "trialError": "Ocorreu um erro",
  "trialProcessing": "A processar...",
  "trialStartButton": "Iniciar Teste Gratuito",
  "paymentModalTitle": "Concluir a compra",
  "completePurchase": "Concluir compra",
  "paymentProcessing": "O seu pagamento está a ser processado. Atualizaremos a subscrição quando estiver concluída.",
  "paymentError": "Ocorreu um erro. Tente novamente.",
  "paymentErrors": {
    "noStoredPlan": "Não foi possível recuperar o plano selecionado.",
    "trialSubscriptionFailed": "Não foi possível iniciar o teste gratuito.",
    "subscriptionIdMissing": "Não foi possível identificar a subscrição.",
    "confirmPaymentFailed": "Não foi possível confirmar o pagamento."
  },
  "supportEmailSubject": "AllDrivers - checkout Stripe indisponível",
  "errorOpeningPortal": "Não foi possível abrir o portal Stripe.",
  "noPlansAvailable": "Nenhum plano disponível",
  "manageInStripe": "Gerir no Stripe",
  "interval": {
    "month": "mês",
    "year": "ano"
  },
  "buyLicense": {
    "setupFee": "Taxa de instalação",
    "once": "uma vez",
    "monthlyAmount": "Valor mensal",
    "selectQuantity": "De quantas licenças precisa?",
    "quantity": "Número de licenças",
    "summary": "Resumo do pedido",
    "plan": "Plano",
    "licenses": "Licenças",
    "total": "Total",
    "totalFirstInvoice": "Total (1.ª fatura)"
  },
  "checkoutReturn": {
    "checkingTitle": "A confirmar o pagamento",
    "checkingDescription": "Estamos a verificar o resultado do checkout.",
    "successTitle": "Pagamento efetuado com sucesso!",
    "successDescription": "A sua licença está ativa e pode aceder ao seu painel.",
    "pendingTitle": "A processar o pagamento",
    "pendingDescription": "Estamos a confirmar o seu pagamento. Pode demorar alguns instantes — atualize daqui a pouco e contacte o suporte se a licença não ficar ativa.",
    "canceledTitle": "Pagamento cancelado",
    "canceledDescription": "Cancelou o checkout. Pode ativar a sua licença quando quiser.",
    "retry": "Tentar novamente",
    "errorTitle": "Não foi possível confirmar o pagamento",
    "errorDescription": "Não conseguimos validar o retorno do checkout. Se já pagou, aguarde alguns minutos ou contacte o suporte.",
    "returnToDashboard": "Ir para o painel"
  },
  "retryPayment": "Tentar novamente",
  "errorFetchingPlans": "Erro ao obter os planos de subscrição",
  "ownerDashboard": {
    "choosePlan": "Escolha o seu plano",
    "save10Percent": "Poupe 10% com o plano anual",
    "14daystrial": "Teste gratuito de 7 dias",
    "startTrial": "Iniciar teste de 7 dias",
    "buyNow": "Comprar Agora",
    "activeDrivers": "Condutores Ativos",
    "hoursLicenses": "Licenças de Horas",
    "availableHoursLicenses": "Horas Disponíveis",
    "gpsLicenses": "Licenças GPS",
    "availableGpsLicenses": "GPS Disponíveis",
    "companyStats": "Estatísticas da Empresa",
    "dau": "Condutores Ativos Diariamente",
    "mau": "Condutores Ativos Mensalmente",
    "employmentsVsLicenses": "Empregos Ativos vs Licenças de Condutor",
    "unassignedDrivers": "Condutores Ativos sem Atribuição",
    "last12Periods": "últimos 12 períodos",
    "last6Weeks": "últimas 6 semanas",
    "unpaidInvoices": "Faturas em Aberto",
    "oldestVehicles": "Viaturas Mais Antigas",
    "highOdometer": "Viaturas com Maior Odómetro",
    "invitations": "Convites (7/30 dias)",
    "sentAcceptedExpired": "enviados/aceites/expirados",
    "inviteDriver": "Convidar Condutor",
    "inviteDriverDesc": "Envie convites para novos condutores",
    "buyLicenses": "Comprar Licenças",
    "buyLicensesDesc": "Adquira licenças adicionais de condutor",
    "today": "Hoje",
    "average": "Média",
    "latest": "Mais recente",
    "last12Days": "últimos 12 dias",
    "last12Months": "últimos 12 meses"
  },
  "planQuestion": "Prefere faturação mensal ou anual?",
  "planHint": "Os preços e a elegibilidade do teste vêm do catálogo atual. Escolha mensal ou anual.",
  "planMonthlyTitle": "Mensal",
  "planAnnualTitle": "Anual",
  "selectPlan": "Selecionar",
  "planMonthlyValue": "{{price}} por licença/mês",
  "planAnnualValue": "{{price}} por licença/ano",
  "planTrialEligible": "Teste grátis de {{days}} dias, sem cartão.",
  "planSetupUnit": "Instalação: {{price}} por veículo, cobrada uma vez.",
  "planAnnualSaving": "Poupa {{save}} por licença/ano.",
  "planEligibilityLoading": "A validar as condições do plano…",
  "planCycleUnavailable": "Indisponível no catálogo atual.",
  "planUnavailable": "Este produto está temporariamente indisponível porque o catálogo não tem todas as condições necessárias.",
  "reviewSelection": "Rever valores",
  "reviewTitle": "Resumo antes de confirmar",
  "reviewProduct": "Produto: {{product}}",
  "reviewRecurringCalculation": "{{quantity}} × {{unit}} = {{total}} recorrentes por {{period}}.",
  "reviewSetupCalculation": "{{quantity}} × {{unit}} = {{total}} de instalação, cobrada uma vez.",
  "reviewAnnualSaving": "Poupa {{unitSave}} por licença ({{totalSave}} no total) face a 12 mensalidades.",
  "reviewChargedToday": "Total cobrado hoje: {{total}}.",
  "reviewNextChargeAfterTrial": "Próxima cobrança: {{total}} após {{days}} dias; depois, a cada mês.",
  "reviewNextCharge": "Próxima cobrança recorrente: {{total}} no próximo {{period}}.",
  "periodMonth": "mês",
  "periodYear": "ano",
  "vatIncluded": "IVA incluído.",
  "startTrialCta": "Começar teste grátis",
  "continueToPayment": "Continuar para pagamento",
  "checkoutSelectionInvalid": "A seleção do chat não corresponde ao catálogo atual. Volte ao chat e escolha novamente.",
  "checkoutEligibilityUnavailable": "Não foi possível validar a elegibilidade desta seleção. Tente novamente.",
  "checkoutSelectionDetails": "{{licenses}} licenças · {{billing}} · {{price}} por licença",
  "checkoutSetupFee": "Instalação: {{price}} por veículo, cobrada uma vez.",
  "returnToChat": "Voltar ao chat",
  "purchaseSuccess": "Compra iniciada com sucesso.",
  "subscriptionError": "Não foi possível iniciar a assinatura.",
  "purchaseFailed": "Não foi possível concluir a compra. Tente novamente.",
  "purchaseCancelled": "Pagamento cancelado ou não confirmado. Tente novamente ou volte ao chat.",
  "paymentSelectionInvalid": "A seleção de checkout é inválida.",
  "billing": {
    "monthly": "mensal",
    "annual": "anual"
  },
  "common": {
    "invite": "Convidar",
    "buy": "Comprar",
    "knowMore": "Saber Mais"
  },
  "productOption_hoursShort": "Registo de horas e descansos.",
  "productOption_gpsShort": "Localização dos veículos em tempo real.",
  "productOption_comboShort": "Horas e GPS no mesmo serviço.",
  "productCardPricing": "{{monthly}}/mês · {{annualMonthly}}/mês no anual",
  "productCardPricingMonthlyOnly": "{{monthly}}/mês",
  "productCardAnnualBilled": "Faturado anualmente a {{total}}",
  "changeProduct": "Alterar produto",
  "viewDetails": "Ver detalhes",
  "hideDetails": "Ocultar detalhes",
  "driverSingleLicense": "1 licença — a sua.",
  "referralAttribution": "Indicação: {{partner}}",
  "registrationOnlyCta": "Continuar só com o registo",
  "registrationOnlyHint": "Conclui o registo sem ativar licenças. Pode comprar licenças mais tarde no painel.",
  "registrationOnlyError": "Não foi possível concluir o registo. Tente novamente.",
  "gpsContractDeclinedMessage": "Não aceitou o contrato do GPS, por isso nada foi cobrado. O GPS precisa do contrato; pode continuar só com o Controlo de Horas.",
  "gpsContractDeclinedHoursOnly": "Continuar só com Controlo de Horas",
  "gpsContractDeclinedReview": "Rever o contrato",
  "gpsContractDeclinedSwitchError": "Não foi possível mudar para o Controlo de Horas. Tente novamente."
}
